// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import claimTypes from './claim-types';
import {combineReducers} from 'redux';
import criteria from './criteria';
import gridApi from './grid-api';
import report from './report';
import reportIsScrollable from '../../shared/reducers/report-is-scrollable';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        claimTypes,
        criteria,
        gridApi,
        report,
        reportIsScrollable,
        showNoResultsFound
    });



// WEBPACK FOOTER //
// ./src/reports/claim-history/reducers/index.js